<template>
  <main>
    <section class="hero">
      <div class="hero-content">
        <!-- الصورة الجديدة التي تمتد على عرض الصفحة -->
        <img
          src="@/assets/pic/mobvol.png"
          alt="Decorative Overlay"
          class="hero-overlay-image"
        />

        <h1><span style="font-weight: 300;"> Discover dishes  </span>
          <span class="no-wrap"><span style="font-weight: 300;">with</span> <strong>Confidence</strong>.</span>
        </h1>
        <p>
          Scan any menu and instantly see what's safe for your allergies and
          dietary preferences. No more guessing or anxiety when eating out.
        </p>

        <div class="app-buttons">
          <a href="https://apps.apple.com/us/app/yum-eats/id6759215448"
            target="_blank"
            ><img
              src="@/assets/pic/app-store-button.png"
              alt="Download on the App Store"
          /></a>
          <a   href="https://play.google.com/store/apps/details?id=com.ebtekar.scaneats"
            target="_blank"
            ><img
              src="@/assets/pic/google-play-button.png"
              alt="Get it on Google Play"
          /></a>
        </div>
      </div>

      <div class="hero-image">
        <img src="@/assets/pic/iphone-mockup.png" alt="YumEat App Screenshot" />
      </div>

      <img
        src="@/assets/pic/Wave.png"
        class="hero-wave"
        alt="Decorative wave"
      />
    </section>

    <!-- Why Choose Us Section -->
    <section class="features-section">
      <h2>Why Choose Us?</h2>
      <p class="section-description">
        YumEat lets you take control of your meals, balance your dietary needs
        and preferences, and understand what's truly in your food.
      </p>

      <div class="features-grid">
        <!-- Feature 1 -->
        <div class="feature-card">
          <div class="feature-icon">
            <img
              src="@/assets/pic/Management icon.png"
              alt="Allergy Protection Icon"
            />
          </div>
          <h3>Allergy Protection</h3>
          <p>
            Real-time scanning for 20+ common allergens including nuts, dairy,
            gluten, and shellfish.
          </p>
        </div>

        <!-- Feature 2 -->
        <div class="feature-card">
          <div class="feature-icon">
            <img
              src="@/assets/pic/Discount Icon.png"
              alt="Instant Scanning Icon"
            />
          </div>
          <h3>Instant Scanning</h3>
          <p>
            Point your camera at any menu and get immediate safety ratings for
            each dish.
          </p>
        </div>

        <!-- Feature 3 -->
        <div class="feature-card">
          <div class="feature-icon">
            <img
              src="@/assets/pic/Discount Icon (1).png"
              alt="Dietary Preferences Icon"
            />
          </div>
          <h3>Dietary Preferences</h3>
          <p>
            Customize for vegetarian, vegan, spice levels, and other personal
            preferences.
          </p>
        </div>

        <!-- Feature 4 -->
        <div class="feature-card">
          <div class="feature-icon">
            <img
              src="@/assets/pic/Discount Icon (2).png"
              alt="Allergens Tracked Icon"
            />
          </div>
          <h3>Allergens Tracked</h3>
          <p>
            From common to rare food sensitivities, never be scared to dine out
            ever again.
          </p>
        </div>
      </div>
    </section>
    <!-- End of Why Choose Us Section -->

    <!-- How It Works Section -->
    <section class="how-it-works-section">
      <!-- SVG لتعريف شكل الهلال (المنحنى) - سيكون غير مرئي -->
      <svg width="0" height="0" style="position: absolute">
        <defs>
          <clipPath id="wave-clip-path" clipPathUnits="objectBoundingBox">
            <!-- انحناء مقعر أعمق من الأعلى (0.22) وانحناء مقعر من الأسفل -->
            <path d="M 0,0 Q 0.5,0.15 1,0 L 1,0.88 Q 0.5,1 0,0.88 Z"></path>
          </clipPath>
          <!-- مسار مخصص للموبايل بانحناء انسيابي ممتاز -->
          <clipPath
            id="wave-clip-path-mobile"
            clipPathUnits="objectBoundingBox"
          >
            <path d="M 0,0 Q 0.5,0.04 1,0 L 1,0.96 Q 0.5,1 0,0.96 Z"></path>
          </clipPath>
        </defs>
      </svg>
      <!-- حاوية جديدة للخلفية المقوسة -->
      <div class="curved-background" style="transform: none"></div>

      <div class="container">
        <h2>How It Works?</h2>
        <p class="section-description">
          YumEat lets you take control of your meals, balance your dietary
          needs and preferences, and understand what's truly in your food.
        </p>

        <div class="how-it-works-grid">
          <!-- Left Steps -->
          <div class="steps-column steps-left">
            <div class="step">
              <img
                src="@/assets/pic/Icon.png"
                alt="Step Icon"
                class="step-icon-img"
              />
              <div class="step-text">
                <h4>Set Up Your Profile</h4>
                <p>
                  Create your personal dietary profile by selecting your
                  allergies, intolerances, and food preferences.
                </p>
              </div>
            </div>
            <div class="step">
              <img
                src="@/assets/pic/Icon.png"
                alt="Step Icon"
                class="step-icon-img"
              />
              <div class="step-text">
                <h4>Scan the Menu</h4>
                <p>
                  Open the app and point your camera at any restaurant
                  menu—whether it's printed, digital, or on a board.
                </p>
              </div>
            </div>
            <div class="step">
              <img
                src="@/assets/pic/Icon.png"
                alt="Step Icon"
                class="step-icon-img"
              />
              <div class="step-text">
                <h4>AI Analysis</h4>
                <p>
                  Our advanced algorithm analyzes each menu item, identifying
                  ingredients and potential allergens.
                </p>
              </div>
            </div>
          </div>

          <!-- Center Phone Image -->
          <div class="phone-image-container">
            <img src="@/assets/pic/phone.png" alt="ScanEats App on Phone" />
          </div>

          <!-- Right Steps -->
          <div class="steps-column steps-right">
            <div class="step">
              <img
                src="@/assets/pic/Icon.png"
                alt="Step Icon"
                class="step-icon-img"
              />
              <div class="step-text">
                <h4>Get Color-Coded Results</h4>
                <p>
                  See immediate visual feedback with our traffic light
                  system—green for safe options, yellow for caution, and red for
                  items containing your allergens.
                </p>
              </div>
            </div>
            <div class="step">
              <img
                src="@/assets/pic/Icon.png"
                alt="Step Icon"
                class="step-icon-img"
              />
              <div class="step-text">
                <h4>Review Detailed Information</h4>
                <p>
                  Tap on any dish to see exactly why it was flagged—view
                  specific ingredients, preparation methods, and suggested
                  alternatives that match your needs.
                </p>
              </div>
            </div>
            <div class="step">
              <img
                src="@/assets/pic/Icon.png"
                alt="Step Icon"
                class="step-icon-img"
              />
              <div class="step-text">
                <h4>Dine with Confidence</h4>
                <p>
                  Order your meal knowing exactly what you're getting. ScanEats
                  gives you the confidence to enjoy dining out without the worry
                  or uncertainty.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End of How It Works Section -->

    <!-- CTA Section: Dine with Confidence -->
    <section class="cta-section">
      <div class="cta-grid">
        <div class="cta-image-collage">
          <img
            src="@/assets/pic/Frame 29.png"
            alt="Collage of delicious food dishes"
          />
        </div>
        <div class="cta-content">
          <span class="cta-subtitle">Your Personal Food Safety Scout</span>
          <h2>
            Dine with
            <span class="no-wrap-mobile">
              <span class="confidence-wrapper"
                ><strong>Confidence</strong
                ><img
                  src="@/assets/pic/Rectangle 1093.png"
                  alt="Underline"
                  class="confidence-underline"
              /></span>
              Not
            </span>
            <br />Concern
          </h2>
          <p>
            ScanEats puts food safety in the palm of your hand. Simply scan any
            restaurant menu, and instantly see which dishes match your dietary
            needs and allergies. Dine with confidence, not concern.
          </p>
          <div class="cta-buttons">
            <a href="https://teams.microsoft.com/l/message/19:a46e26bf-e5d6-475b-b36e-9ae053b1f887_a8154fc7-c05a-4169-99c3-8a0cd66b7cd9@unq.gbl.spaces/1778661457414?context=%7B%22contextType%22%3A%22chat%22%7D"
              target="_blank"
              ><img src="@/assets/pic/Button.png" alt="Download for iOS"
            /></a>
            <a href="#"
              ><img
                src="@/assets/pic/Button (1).png"
                alt="Download for Android"
            /></a>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "HomeView",
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@300;400;500;700;900&display=swap');

/*
  ملف: css/home.css
  يحتوي على الأنماط الخاصة بصفحة Home.html
*/

main {
  padding-top: 85px; /* تعديل دقيق ليتناسب مع الهامش السلبي للـ Hero وإلغاء الفراغ الأبيض */
  font-family: 'Urbanist', sans-serif;
}

/* -------------------------------------- */
/* 5. تصميم المحتوى الرئيسي (Home Page Specific) + الخلفيات */
/* -------------------------------------- */
.hero {
  /* =================================================== */
  /* التعديل: العودة للقيم الأصلية مع ضبط دقيق لعدم وجود فراغ */
  margin-top: -85px; 
  padding-top: 135px; 
  /* =================================================== */

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 5%;
  padding-right: 5%;
  min-height: 90vh;
  background-color: transparent; /* جعل خلفية القسم شفافة */
  position: relative;
  overflow: hidden;
  background-image: url("~@/assets/pic/Oval.png");
  background-position: 0 -20px; /* تم دفع الخلفية للأعلى قليلاً لإزالة الفراغ الأبيض */
  background-repeat: no-repeat;
  background-size: 50% auto;
  /* =================================================== */
}

/* =================================================== */
/* استخدام عنصر زائف (pseudo-element) لتطبيق الدوران على الشكل الثاني Oval-(1).png */
.hero::after {
  content: "";
  position: absolute;
  width: 978px;
  height: 582px;
  top: 233px; /* إنزال الشكل أكثر للأسفل */
  right: -150px; /* التحكم في الموضع من اليمين. القيمة السالبة تدفعها للخارج قليلاً */
  background-image: url("~@/assets/pic/Oval-(1).png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  transform: rotate(-15deg);
  mask-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.3) 20%,
    rgba(0, 0, 0, 0.7) 40%,
    rgba(0, 0, 0, 0.7) 80%,
    rgba(0, 0, 0, 1) 100%
  );
  z-index: 0;
}
/* =================================================== */

.hero-content {
  flex: 1;
  max-width: 500px;
  z-index: 2;
  direction: ltr;
  text-align: left;
  margin-top: -270px; /* زيادة رفع المحتوى للأعلى بشكل أكبر */
}

.hero-image {
  flex: 1;
  text-align: right;
  z-index: 5; /* تخفيض القيمة لتكون تحت قائمة الجوال (z-index: 999) */
  margin-top: 40px; /* تقليل الهامش لرفع الصورة للأعلى */
  overflow: hidden; /* منع المحتوى الداخلي (الصورة) من التسبب في تمرير أفقي */
  transform: translateX(15%); /* تقليل الإزاحة ليتناسب مع الفيجما ولا يختفي في الشاشات الصغيرة */
}

.hero-image img {
  max-width: 600px; /* تعديل الحجم ليتناسب مع الموضع الجديد */
  height: auto;
  display: block;
  transform: rotate(3deg); /* إزالة الإزاحة الأفقية من الصورة نفسها */
}

.hero h1 {
  font-family: 'Urbanist', sans-serif;
  font-size: 56px;
  margin-bottom: 20px;
  color: #333;
  font-weight: 300;
  line-height: 68px;
  letter-spacing: 0.2px;
}

.hero h1 strong {
  color: #000;
  font-weight: 900;
}

.no-wrap {
  white-space: nowrap; /* منع النص من النزول لسطر جديد في الشاشات الكبيرة */
}

.hero p {
  font-size: 20px; /* تكبير حجم الخط قليلاً */
  color: #444;
  margin-bottom: 30px;
}

.app-buttons a {
  display: inline-block;
  margin-right: 10px;
}

.app-buttons img {
  width: 150px;
  height: auto;
}

/* تصميم متجاوب للمحتوى الرئيسي */
@media (max-width: 1087px) {
  /* ===== تصميم الأجهزة اللوحية (Tablets) ===== */
  .hero {
    /* الحفاظ على التخطيط المكون من عمودين مع تعديلات */
    background-size: 60% auto; /* تعديل حجم القوس العلوي */
    padding-top: 100px;
    padding-bottom: 100px;
    min-height: auto;
    gap: 20px;
  }
  .hero-content {
    margin-top: -150px;
  }
  .hero h1 {
    font-size: 38px;
  }
  .hero-image {
    margin-top: 50px;
    transform: translateX(10%); /* تقليل إزاحة الهاتف لليمين ليناسب التابلت */
  }
  .hero-image img {
    max-width: 500px; /* تصغير حجم الصورة قليلاً في الشاشات اللوحية */
    transform: rotate(3deg); 
  }
  .hero::after {
    display: block; /* إظهار القوس الزخرفي */
    transform: rotate(-15deg) scale(0.7); /* تصغير حجم القوس وتدويره */
    right: -40vw; /* زيادة الإزاحة لليمين بشكل كبير لمنع الخروج عن الشاشة */
    top: 15vh; /* تعديل الموضع العمودي */
  }
}

@media (max-width: 768px) {
  /* ===== تصميم الجوال (Mobiles) ===== */
  .hero {
    flex-direction: column;
    text-align: center;
    padding-bottom: 150px; /* مساحة كافية للموجة في الأسفل */
    min-height: auto;

    /* إعادة ضبط الهامش والقيمة الداخلية في الجوال */
    margin-top: 0;

    /* إخفاء الأشكال البيضاوية في الشاشات الصغيرة لتحسين التخطيط */
    background-image: none;
  }
  .hero::after {
    display: none; /* إخفاء القوس الزخرفي الثاني في الشاشات الصغيرة */
  }

  .hero-content,
  .hero-image {
    max-width: 100%;
    text-align: center;
  }

  .hero-content {
    margin-top: 0; /* إزالة الهامش السالب ليعود المحتوى لمكانه الطبيعي */
    text-align: left; /* محاذاة النص لليسار في الشاشات الصغيرة */
  }

  .hero-image {
    margin-top: 40px;
    text-align: center;
    transform: none; /* إلغاء إزاحة الحاوية لإظهار الصورة */
    position: relative; /* ضروري لتحديد موضع الصورة الجديدة */
    order: -1; /* وضع الصورة فوق النص في الشاشات الصغيرة */
  }

  .hero-image img {
    transform: none; /* إزالة الإزاحة الأفقية لمنع الفراغ الجانبي */
    max-width: 400px; /* حجم مناسب للأجهزة اللوحية */
  } /* تحسينات إضافية للجوال */
  .hero h1 {
    font-size: 52px; /* تكبير حجم الخط في شاشات الجوال */
    white-space: normal; /* السماح للنص بالالتفاف */
  }
  .hero h1 .no-wrap {
    display: block; /* جعل الكلمة الأخيرة تنزل لسطر جديد */
  }

  .app-buttons {
    display: flex; /* استخدام فليكس بوكس */
    justify-content: center; /* توسيط الأزرار */
    flex-wrap: nowrap; /* منع الأزرار من النزول لسطر جديد */
    gap: 10px; /* مسافة بين الأزرار */
  }
  .app-buttons img {
    width: 180px; /* تكبير حجم أزرار التحميل في الجوال */
  }
  .hero-image {
    display: block; /* التأكد من أن حاوية الصورة مرئية */
    /* أنماط .hero-image img (مثل max-width و transform: none) مطبقة بالفعل في @media (max-width: 1087px) وستظل سارية */
  }

  .features-section {
    padding-top: 0; /* إزالة الحشوة العلوية */
    margin-top: -80px; /* إضافة هامش سالب لرفع القسم للأعلى بشكل كبير */
  }
}

@media (max-width: 576px) {
  /* تحسينات إضافية للجوالات الصغيرة */
  .hero h1 {
    font-size: 24px;
  } /* تصغير حجم الخط أكثر للشاشات الأصغر */
  .hero p {
    font-size: 16px;
  }
  .hero-image img {
    max-width: 320px; /* تصغير حجم الصورة أكثر */
  }
  .app-buttons img {
    width: 150px; /* تصغير حجم أزرار التحميل قليلاً */
  }
}

@media (max-width: 360px) {
  /* نقطة توقف إضافية للجوالات الصغيرة جداً */
  .app-buttons {
    flex-direction: row; /* الحفاظ على ترتيب الأزرار أفقياً */
    align-items: center; /* توسيط الأزرار */
  }
}
/* -------------------------------------- */
/* 6. Wave Decoration */
/* -------------------------------------- */
.hero-wave {
  position: absolute;
  bottom: -1px; /* Position at the very bottom, -1px to avoid gaps */
  left: 0;
  width: 100%;
  height: 210px; /* زيادة ارتفاع الموجة */
  z-index: 1; /* Ensure it's above background elements but below main content if needed */
  transform: scaleX(-1); /* قلب الصورة رأسياً */
}

/* -------------------------------------- */
/* 7. Features Section ("Why Choose Us?") */
/* -------------------------------------- */
.features-section {
  padding: 100px 5% 50px;
  background-color: #fff;
  text-align: center;
}

.features-section h2 {
  font-family: 'Urbanist', sans-serif;
  font-size: 42px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.features-section .section-description {
  font-size: 18px;
  color: #000;
  font-weight: 400;
  line-height: 32px;
  max-width: 700px;
  margin: 0 auto 60px;
}

.features-grid {
  display: flex; /* استخدام Flexbox لتوسيط البطاقات ذات الحجم الثابت */
  justify-content: center;
  flex-wrap: wrap; /* للسماح للبطاقات بالانتقال لسطر جديد في الشاشات الصغيرة */
  gap: 70px; /* زيادة المسافة بين البطاقات بشكل كبير */
  text-align: center;
  margin-top: 80px; /* تعديل الهامش العلوي */
}

.feature-card {
  background-color: #fff; /* جعل خلفية البطاقة بيضاء */
  width: 270px; /* العرض المطلوب للبطاقة البيضاء */
  height: 200px; /* الارتفاع المطلوب للبطاقة البيضاء */
  border-radius: 25px; /* نصف القطر المطلوب للبطاقة البيضاء */
  border: none; /* إزالة أي حدود سابقة */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.07); /* ظل خفيف جداً */
  color: #333; /* جعل لون النص الافتراضي داكناً */
  position: relative; /* لتحديد موضع الأيقونة بشكل مطلق */
  text-align: center; /* توسيط النصوص داخل البطاقة */
  padding: 50px 20px 20px; /* تعديل الـ padding لإضافة مسافات جانبية وسفلية */
}

.feature-icon {
  width: 60px; /* إعادة الأيقونة لحجمها الصغير */
  height: 60px; /* إعادة الأيقونة لحجمها الصغير */
  background-color: transparent; /* إزالة الخلفية البرتقالية الأصلية */
  border-radius: 15px; /* تعديل نصف القطر ليتناسب مع الحجم الجديد */
  position: absolute; /* وضع الأيقونة بشكل مطلق */
  top: -30px; /* رفع الأيقونة لنصف ارتفاعها خارج البطاقة */
  left: 50%; /* الحفاظ على التوسيط الأفقي */
  transform: translateX(-50%); /* ضبط التوسيط الدقيق */
  display: flex; /* استخدام فليكس بوكس لتوسيط الصورة داخل الأيقونة */
  justify-content: center;
  align-items: center;
}

.feature-icon img {
  max-width: 100%; /* التأكد من أن الصورة لا تتجاوز حجم الأيقونة */
  max-height: 100%;
}

.feature-card h3 {
  font-size: 18px; /* تصغير حجم العنوان */
  color: #333; /* جعل عنوان الميزة داكناً */
  margin-bottom: 15px; /* زيادة المسافة بين العنوان والنص */
}

.feature-card p {
  font-size: 16px;
  color: #72737D;
  font-weight: 400;
  line-height: 26px;
}

/* رفع الكروت الطرفية قليلاً */
.features-grid .feature-card:first-child,
.features-grid .feature-card:last-child {
  transform: translateY(-30px); /* استخدام transform لرفع البطاقات */
}

@media (max-width: 1087px) {
  /* تعديل للكروت الطرفية في الشاشات الأصغر */
  .features-grid .feature-card:first-child,
  .features-grid .feature-card:last-child {
    transform: translateY(
      0
    ); /* إلغاء الرفع عندما لا تكون البطاقات في صف واحد */
  }
  .features-grid {
    gap: 60px; /* زيادة المسافة بين البطاقات عند تكديسها */
  }
}

@media (max-width: 768px) {
  /* تبديل الكارت الأول والأخير في الجوال */
  .features-grid {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .features-grid .feature-card:first-child {
    order: 1; /* يجعله الأخير */
  }
  .features-grid .feature-card:last-child {
    order: -1; /* يجعله الأول */
  }
}

/* -------------------------------------- */
/* 8. How It Works Section                */
/* -------------------------------------- */
.how-it-works-section {
  margin-top: 0; /* إزالة الهامش السالب بعد حذف الموجة */
  padding: 0 5% 250px; /* زيادة الحشوة السفلية لزيادة ارتفاع القسم */
  background-color: transparent; /* جعل الخلفية الأساسية شفافة */
  color: #fff; /* تغيير لون النص الافتراضي إلى أبيض */
  text-align: center;
  position: relative; /* ضروري لضمان عمل overflow بشكل صحيح */
}

/* حاوية الخلفية البرتقالية المقوسة */
.curved-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ff4422; /* اللون البرتقالي */
  z-index: 0; /* وضع الخلفية في طبقة سفلية */
  clip-path: url(#wave-clip-path);
  /* transform: scaleY(-1); */ /* تم إزالة القلب والاعتماد على المسار الجديد */
}

.how-it-works-section .container {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 18vh; /* استخدام وحدة vh لدفع المحتوى للأسفل بشكل متجاوب */
  position: relative; /* جعل المحتوى فوق الخلفية */
  z-index: 1;
  /* خاصية لمنع النص من الخروج عن حدود الحاوية في الشاشات الصغيرة جداً */
  overflow-wrap: break-word;
}

@media (max-width: 768px) {
  .how-it-works-section .container {
    padding-top: 12vh;
  } /* تقليل الحشوة العلوية في الجوال */
  .how-it-works-section {
    padding-bottom: 100px;
  } /* تقليل الحشوة السفلية في الجوال */
}

.how-it-works-section h2 {
  font-family: 'Urbanist', sans-serif;
  font-size: 42px;
  color: #fff; /* تغيير لون العنوان إلى أبيض */
  margin-bottom: 15px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.how-it-works-section .section-description {
  font-size: 16px;
  max-width: 600px;
  color: #fff; /* تغيير لون النص الفرعي إلى أبيض */
  margin: 0 auto 80px;
}

.how-it-works-grid {
  display: grid;
  grid-template-columns: 1fr auto 1fr; /* استعادة الشبكة الأصلية (3 أعمدة) */
  align-items: center; /* استعادة المحاذاة للمنتصف */
  gap: 80px; /* استعادة المسافة الأصلية */
}

.steps-column {
  display: flex;
  flex-direction: column;
  gap: 30px; /* تقليل المسافة بين الخطوات أكثر */
}

.step {
  display: flex;
  flex-direction: column; /* الأيقونة فوق النص */
  /* إزالة align-items: center; من هنا للسماح بمحاذاة النص */
}

.step-icon-img {
  width: 20px; /* تكبير حجم الأيقونة قليلاً */
  height: 20px; /* تكبير حجم الأيقونة قليلاً */
  margin-bottom: 12px; /* تقليل المسافة بين الأيقونة والنص */
  flex-shrink: 0;
}

/* الخطوات على اليسار: الأيقونة على اليمين (أقرب للهاتف) */
.steps-left .step {
  align-items: flex-end; /* محاذاة الأيقونة والنص لليمين */
}

.steps-left .step-text {
  text-align: right; /* محاذاة النص لليمين في العمود الأيسر */
  /* لا حاجة لـ width: 100% هنا، text-align يعمل داخل العنصر */
}

/* الخطوات على اليمين: الأيقونة على اليسار (أقرب للهاتف) */
.steps-right .step {
  align-items: flex-start; /* محاذاة الأيقونة والنص لليسار */
}

.steps-right .step-text {
  text-align: left; /* محاذاة النص لليسار في العمود الأيمن */
  /* لا حاجة لـ width: 100% هنا، text-align يعمل داخل العنصر */
}

.step h4 {
  font-size: 20px; /* تكبير حجم العنوان قليلاً */
  font-weight: 700; /* تجعيده بولد */
  color: #fff; /* تغيير لون عناوين الخطوات إلى أبيض */
  margin-bottom: 10px;
}

.step p {
  font-size: 14px; /* تكبير حجم الخط قليلاً */
  line-height: 1.7;
  color: #fff; /* تغيير لون نص الخطوات إلى أبيض */
  max-width: 320px; /* زيادة العرض الأقصى للنص لجعله يلتف على 3 أسطر */
}

/* تعديل خاص للجهة اليسرى لجعلها 3 أسطر أيضاً */
.steps-left .step p {
  max-width: 250px;
}

.phone-image-container img {
  max-width: 300px; /* استعادة حجم الهاتف الأصلي */
  height: auto;
  /* إزالة الهوامش الإضافية التي لم تعد ضرورية */
}

/* تصميم متجاوب لقسم How It Works */
@media (max-width: 1087px) {
  .how-it-works-grid {
    grid-template-columns: 1fr; /* تغيير الشبكة لعمود واحد في الشاشات الصغيرة */
    gap: 30px; /* تقليل المسافة بين مجموعات الخطوات في الشاشات الصغيرة */
  }

  .phone-image-container {
    order: -1; /* تغيير ترتيب صورة الهاتف لتكون في الأعلى */
    margin: 20px 0 40px; /* تقليل الهامش العلوي لتقريب الصورة من النص */
  }

  .steps-left,
  .steps-right {
    order: 1; /* الخطوات اليسرى أولاً */
  }

  .steps-left .step-text,
  .steps-right .step-text {
    text-align: center; /* توسيط النص في شاشات الجوال */
  }

  .steps-right {
    order: 3; /* الخطوات اليمنى أخيراً */
  }

  .steps-left .step,
  .steps-right .step {
    align-items: center; /* توسيط محتوى الخطوات في الجوال */
  }
}
/* تطبيق المسار الجديد الأقل عمقاً في شاشات التابلت والجوال */
@media (max-width: 1087px) {
  .curved-background {
    clip-path: url(#wave-clip-path-mobile);
  }
}

/* -------------------------------------- */
/* 9. Bottom Wave Separator (Wave2.png)   */
/* -------------------------------------- */

/* -------------------------------------- */
/* 10. CTA Section (Dine with Confidence) */
/* -------------------------------------- */
.cta-section {
  background-color: #fff;
  padding: 100px 5%; /* إزالة الهامش السالب بعد حذف الموجة */
}

.cta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 60px;
  max-width: 1200px;
  margin: 0 auto;
}

.cta-image-collage {
  /* منع الصورة الأكبر من الحاوية من التسبب في التمرير الأفقي */
  overflow: hidden; /* تم التعليق على هذا السطر للسماح بظهور الصورة كاملة */
}

.cta-image-collage img {
  max-width: 100%; /* جعل الصورة تتناسب مع عرض الحاوية */
  height: auto;
  /* transform: translateX(-5%) translateY(-5%); */ /* إزالة الإزاحة لعرض الصورة بشكل صحيح */
}

.cta-content .cta-subtitle {
  color: #ff4422; /* لون أحمر/برتقالي */
  font-weight: normal;
  display: block;
  margin-bottom: 10px;
}

.cta-content h2 {
  font-family: 'Urbanist', sans-serif;
  font-size: 42px;
  color: #333;
  /* تأكد من أن h2 لا يمتلك background-color يغطي الصورة */
  background-color: transparent;
  margin-bottom: 20px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.cta-content h2 strong {
  position: relative; /* لجعل z-index يعمل على النص */
  z-index: 1; /* لجعل النص يظهر فوق الصورة */
}

.cta-content h2 .confidence-wrapper {
  position: relative;
  display: inline-block;
}

.cta-content h2 .confidence-underline {
  position: absolute;
  bottom: 0; /* تعديل الموضع لرفع الصورة للأعلى قليلاً */
  left: 0; /* ضبط الموضع ليكون تحت بداية الكلمة */
  width: 104%; /* جعل عرض الصورة يطابق عرض الكلمة */
  height: auto; /* للحفاظ على نسبة العرض إلى الارتفاع */
  z-index: 0; /* وضع الصورة في طبقة عادية، ستظهر خلف النص بسبب z-index للنص */
  transform: rotate(360deg); /* دوران الصورة بزاوية 180 درجة (قلب رأسي وأفقي) */
}

.cta-content p {
  font-size: 16px;
  color: #444;
  line-height: 1.8;
  margin-bottom: 30px;
}

.cta-buttons a {
  display: inline-block;
  margin-right: 10px; /* المسافة الأصلية بين الأزرار */
}

@media (max-width: 992px) {
  .cta-grid {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .cta-image-collage {
    order: -1; /* تغيير الترتيب لوضع الصورة فوق النص */
    margin-top: 40px;
  }

  .cta-image-collage img {
    transform: translateX(0) translateY(0); /* إزالة الإزاحة في الشاشات الصغيرة */
    max-width: 100%;
  }

  .cta-buttons {
    display: flex;
    flex-direction: column; /* وضع الأزرار تحت بعضها في الشاشات الصغيرة */
    align-items: center; /* توسيط الأزرار أفقياً */
    gap: 15px; /* مسافة بين الأزرار */
  }

  .cta-buttons img {
    width: 280px; /* تكبير عرض الأزرار في الشاشات الصغيرة */
    height: auto;
  }

  /* تنسيق العنوان في الشاشات الصغيرة */
  .cta-content h2 {
    font-size: 24px; /* تصغير حجم الخط أكثر ليناسب الشاشات الصغيرة */
    white-space: nowrap; /* منع السطر الأول من الالتفاف */
  }
  .cta-content h2 br {
    display: block; /* التأكد من أن وسم <br> يجبر النص على النزول لسطر جديد */
  }
}

/* -------------------------------------- */
/* 11. Hero Overlay Image (mobvol.png)    */
/* -------------------------------------- */
.hero-overlay-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%; /* عرض العنصر الحاوي لمنع تجاوز الحدود */
  height: auto;
  z-index: 1; /* وضعها خلف صورة الهاتف (z-index: 2) */
  pointer-events: none; /* السماح بالتفاعل مع العناصر التي تحتها */
  display: none; /* إخفاء الصورة بشكل افتراضي (في الشاشات الكبيرة) */
}

/* إظهار الصورة في الشاشات الصغيرة فقط */
@media (max-width: 768px) {
  .hero-overlay-image {
    display: block; /* إظهار الصورة في الشاشات الصغيرة */
    top: 30px; /* إنزال الصورة للأسفل بمقدار 40 بكسل */
  }

  .hero-image img {
    /* إعادة ضبط الإزاحة لضمان التوسيط الصحيح بعد إخفاء الصورة العلوية */
    transform: none; /* التأكيد على إزالة الإزاحة */
  }
}
</style>
